import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DropTarget } from 'react-dnd'
import ItemTypes from './ItemTypes'
import FrequencyCard from 'shared/components/Cards/frequency_card';

import * as FontAwesome from 'react-icons/lib/fa';
import PeriodicalIteam from 'shared/components/PeriodicalIteam/index';

import Periodical from './periodical_iteam';



const FrequencyListTarget = {
	drop(props, monitor)
	{
		props.onDrop(monitor.getItem())
		return {id:props.id,name:props.name,occur_frequency:props.occur_frequency,icon:props.icon}
	},

}

function collect(connect, monitor) {
	return {
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: monitor.canDrop(),
	};
  }

const propTypes = {
	connectDropTarget: PropTypes.func.isRequired,
		isOver: PropTypes.bool.isRequired,
		canDrop: PropTypes.bool.isRequired,
		onDrop: PropTypes.func.isRequired,
  };

class FrequencyList extends Component {
	render() {
		const { id, name } = this.props;
		const {
			isOver,
			canDrop,
			connectDropTarget,
			content
		} = this.props;
		const isActive = isOver && canDrop;

		return connectDropTarget(
			<div>
				<FrequencyCard
					name={name}
					id={id}
					head={this.props.name}
					isActive={isActive}
					occur_frequency={this.props.occur_frequency}
					content={content.map(x =>
						<div key={x.id}>
							{id == x.occurrence_id ? (
								<div className="alloc-dropped-card">
									<Periodical
										id={x.id}
										name={x.name}
										type={x.name}
										occur_frequency={x.occur_frequency}
										is_separately_charge={x.is_separately_charge}
										deleteClick={this.props.deleteClick}
										icon={x.icon}
										onpClick={this.props.onpClick}
										enable={1}
									>
										<PeriodicalIteam
											id={x.id}
											key={x.id}
											icon={x.icon}
											enable={1}
											deleteClick={this.props.deleteClick}
											onpClick={this.props.onpClick}
											font_icon={<FontAwesome.FaArrows />}
											name={x.name}
											is_separately_charge={x.is_separately_charge}
										/>
									</Periodical>
									<div className="alloc-dropped-card__status">Assigned</div>
								</div>
							) : ''}
						</div>
					)}
				/>
			</div>
		)
	}
}


FrequencyList.propTypes = propTypes;


export default DropTarget(ItemTypes.BOX, FrequencyListTarget, collect)(FrequencyList);



// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalConfig/frequency_list.js